import type { Location } from '../types';

/**
 * The number a customer sees BEFORE booking: the studio's Customer Experience
 * line (CE_Phone_Number__c, `publicPhone`), falling back to the booking desk
 * when a store has no CE line on file. The post-booking confirmation shows
 * the booking desk (`phone`) and does not use this — CC, 2026-10-26.
 */
export function prebookingPhone(location: Pick<Location, 'phone' | 'publicPhone'> | null | undefined): string | undefined {
  const ce = location?.publicPhone?.trim();
  if (ce) return ce;
  const desk = location?.phone?.trim();
  return desk || undefined;
}
